import { insert_positionService } from '../_services';

const state = { onRequest: false };

const actions = {
  upload({ dispatch, commit }, data) {
        commit('request');

        insert_positionService.upload(data)
            .then(
                resp => {
                    commit('success_data', resp);
                    dispatch('alert/success', "Position Inserted Successfully", { root: true });
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state) {
      state.onRequest = false;
    },
    clear_data(state) {
      state.onRequest = false;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const insert_positions = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
